import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@seahorse/ui";
import CoTraderChatTileComponent from "../Components/CoTraderChatTileComponent";
import { setSessionVariable } from "../Utils/CoTraderUtils";
import CoTraderTitleComponent from "../Components/CoTraderTitleComponent";

interface Context {
  id?: {
    [key: string]: string;
  };
  name?: string;
  type: string;
  [s: string]: any;
}
interface ContextProp {
  context: Context;
  currencyList: string[]; // Ensure that the type of the prop is defined
}
const CoTraderCurrencyChatTile: React.FunctionComponent<ContextProp> = ({
  context,
  currencyList,
}) => {
  const theme = useTheme();
  const [currencyPair, setCurrencyPair] = useState("USDJPY");
  const [useContext, setUseContext] = useState(true);
  const [userLanguage, setUserLanguage] = useState(localStorage.getItem("user_language") || "English");
  const [updateSpeed, setUpdateSpeed] = useState(3);
  const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      padding: "10px",
      backgroundColor: theme.globallink.colors.DarkGrey[500],
    },
    chatContainer: {
      display: "flex",
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
      paddingTop: "8px",
      borderRadius: "8px",
    },
    title: {
      color: "#E0E0E0",
      fontSize: "16px",
      fontWeight: "bolder",
      display: "flex",
      justifyContent: "space-between",
      padding: "4px",
      alignItems: "center",
      // height: "76px", // Align items vertically in the center
    },
  });

  const classes = useStyles();

  useEffect(() => {
    if (!useContext) {
      return;
    }

    const currencyPairReceived = context?.instruments?.[0]?.id?.ticker;
    if (currencyPairReceived && currencyList?.includes(currencyPairReceived)) {
      setCurrencyPair(currencyPairReceived);
    }
  }, [context, currencyList, useContext]);

  useEffect(() => {
    setSessionVariable(currencyPair);
  }, [currencyPair]);

  return (
    <div className={classes.container}>
      <CoTraderTitleComponent
        currencyPair={currencyPair}
        currencyList={currencyList}
        setCurrencyPair={setCurrencyPair}
        setUpdateSpeed={setUpdateSpeed}
        setUseContext={setUseContext}
        setUserLanguage={setUserLanguage}
        userLanguage={userLanguage}
      />
      <div className={classes.chatContainer}>
        <CoTraderChatTileComponent
          currencyPair={currencyPair}
          variant="preTrade"
        />
      </div>
    </div>
  );
};

export default CoTraderCurrencyChatTile;
